import React, { useState } from 'react';
import styles from './index.module.less';
import formTitle from '@/assets/themes/logo.svg';
import { Form, Button, message, Input } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import Cookies from 'js-cookie'
import API from '@/utils/apiConfig';
import request from '@/utils/request';
import ReactSlideVerify from './slideVerify/index'
import img1 from '../../assets/images/slideVerify/img01.png';
import img2 from '../../assets/images/slideVerify/img02.png';
import img3 from '../../assets/images/slideVerify/img03.png';
import img4 from '../../assets/images/slideVerify/img04.png';
import img5 from '../../assets/images/slideVerify/img05.png';
import img6 from '../../assets/images/slideVerify/img06.png';
import img7 from '../../assets/images/slideVerify/img07.png';

const { login } = API;

const Login = (props) => {

  const onFinish = (values) => {
    request().post(login, values).then(res => {
      if (res && res.data.errCode === 0) {
        let data = res.data.data;
        message.success('登录成功');
        Cookies.set('token', `${data.token}`, { expires: 7 })
        Cookies.set('username', `${data.user.username}`, { expires: 7 })
        Cookies.set('name', `${data.user.name || data.user.username || ''}`, { expires: 7 })
        Cookies.set('userType', data.user.type || 'teacher', { expires: 7 })
        Cookies.set("userId", data.user._id || '', { expires: 7 })
        Cookies.set("userCode", data.user.code || '', { expires: 7 })
        Cookies.set("encc", data.user.password || '', { expires: 7 })
        if (data.user.link) {
          Cookies.set("terminal", '//' + data.user.link || '', { expires: 7 })
        }
        sessionStorage.removeItem('__terming_ip___')
        props.history && props.history.push('/dashboard')
      } else {
        message.error((res && res.data.message) || '登录失败')
      }
    })
  }

  let [showSlideVerify, setShowVerify] = useState(false)
  const [form] = Form.useForm()
  const onSuccess = () => {
    console.log('Success!')
    setTimeout(() => {
      setShowVerify(false)
      setVerifyStatus(true)
      form.validateFields(['verify'])
    }, 0)
  }
  const onFail = () => {
    console.log('Failed!')
  }
  const onRefresh = () => {
    console.log('Refresh!')
  }

  let imgVerify =
    <div style={{ display: showSlideVerify ? '' : 'none' }} className={styles['slide-cont']}>
      <CloseOutlined onClick={() => { setShowVerify(false) }} className={styles['slide-close']} />
      <ReactSlideVerify
        l={40}
        r={8}
        w={370}
        h={191}
        accuracy={5}
        sliderText="向右滑动"
        imgs={[img1, img2, img3, img4, img5, img6, img7]}
        success={onSuccess}
        fail={onFail}
        refresh={onRefresh}
      />
    </div>

  let [verifySuc, setVerifyStatus] = useState(false)
  let verifyBtn
  if (!verifySuc) {
    verifyBtn = <div onClick={() => { setShowVerify(true) }} className={styles['check-bar']}>
      <i className='icon iconfont icon-very'></i>
      <span>点击验证</span>
    </div>
  } else {
    verifyBtn = <div className={styles['check-bar-suc']}>
      <CheckOutlined className={styles['check-icon']} />
      <span>验证通过</span>
    </div>
  }

  const validatorImgVerify = (rule, value) => {
    console.log(rule)
    console.log(value)
    if (verifySuc) {
      return Promise.resolve()
    } else {
      return Promise.reject(new Error('fail!'))
    }
  }



  return (
    <div className={styles.login_page}>
      {/* <header className={styles.login_header}>
                <img className={styles.login_logo} src={logo} alt='logo' />
                <div className={styles.login_user}>
                    <img src={userLogo} alt='user-logo' />
                    <span>未登录</span>
                </div>
            </header> */}
      <div className={styles.form_container}>
        <div className={styles.form_title}>
          <img src={formTitle} alt='form-title' />
        </div>
        <div className={styles.form_bg}>
          <div className={styles.form_tit}>欢迎登录</div>
          <Form name="basic" form={form} onFinish={onFinish} initialValues={{ username: '', password: '' }}>
            <Form.Item
              // style={{ marginBottom: '37px' }}
              name="username"
              rules={[{ required: true, message: '请输入用户名/手机号！' }]}
            >
            <div className='line'><i className='icon iconfont icon-user'></i> <Input size="large" placeholder='用户名/手机号' /></div>
            </Form.Item>

            <Form.Item
              // style={{ marginBottom: '0' }}
              name="password"
              rules={[{ required: true, message: '请输入登录密码！' }]}
            >
          <div className='line'><i className='icon iconfont icon-password'></i>  <Input.Password size="large" placeholder='登录密码' /></div>
            </Form.Item>
            <Form.Item
              name="verify"
              className='veriry'
              rules={[{ validator: validatorImgVerify, message: '请通过验证！' }]}
            >
              {verifyBtn}
            </Form.Item>
            {/* 图片验证 */}
            {imgVerify}
            <Form.Item className='veriry'>
              <Button
                size="large"
                style={{ width: '100%' }}
                type="primary"
                htmlType="submit"
              >
                登录
              </Button>
            </Form.Item>
            <div className={styles.forgetPass}>
              <span
                onClick={() => {
                  message.info('请联系客服，进行密码重置操作');
                }}
              >
                忘记密码?
              </span>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default Login;
